export default __webpack_public_path__ + "static/media/renaldo_andrews_feature2.9ee5417e.jpeg";